import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { toastr } from 'react-redux-toastr'
import momentDurationFormatSetup from 'moment-duration-format'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { requestEventVideo } from '../../../../../shared/api/action/AlertActions'
import { getDurationTimeFormat, getDurationUnitFormat } from '../../../component/helpers/helperTripsGrid'
import momenttz from '../../../component/helpers/momenttz'
import './MarkerInfoPopup.sass'

momentDurationFormatSetup(moment);

const TripSpeedEventPopup = (props) => {
	const { mapUI, user, event, position, toggleLoader, setShowSpeedEventPopup } = props;
	const { t } = useTranslation()

	const vehicleSpeed = () => {
		let speedRes = +event.speed || 0;
		if (user.speed_unit === 'mph') {
			speedRes /= 1.609344
		}

		return speedRes.toFixed(0)
	}

	const vehicleSpeedLimit = () => {
		if (!event.speed_limit) {
			return 'N/A';
		}

		let speedRes = +event.speed_limit || 0;
		if (user.speed_unit === 'mph') {
			speedRes /= 1.609344;
		}

		return Math.round(speedRes / 5) * 5;
	}

	const createCustomClip = (e) => {
		e.preventDefault();

		const { event, device_id } = props
		let startTs = momenttz(event.start_ts);
		let endTs = momenttz(event.end_ts);
		const diff = moment(event.end_ts).diff(moment(event.start_ts), 'seconds')
		if (diff < 10) {
			startTs = momenttz(event.start_ts).add(-10, 'seconds');
		} else if (diff > (5 * 60)) {
			endTs = momenttz(event.start_ts).add(5 * 60, 'seconds');
		}

		const params = {
			device_id,
			start_ts: startTs.format('YYYYMMDDHHmmss'),
			end_ts: endTs.format('YYYYMMDDHHmmss'),
		}
		toggleLoader(true);
		requestEventVideo(params)
			.then((res, err) => {
				toggleLoader(false);
				toastr.success('', t('toastMessage.toastrSuccessCVR'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('requestCustomVideo error:', error.response, error);
				let errDescription = t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.erro
				}
				toastr.error(errDescription);
			});
	}

	const getContent = () => {
		const content = document.createElement('div');
		content.className = "markerInfoPopup markerHistoryPopup";
		content.innerHTML = `
		<div class="headerWrapper">
			<div class="header">
				<div class="row">
					<div class="menu col-md-12 col-sm-12 col-12">
						<div class="trip-speed-event-popup col-md-12 col-sm-12 col-12" style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 10px; padding: 5px 8px 0px; color: #fff; min-width: 120px;">
							<div class="drive-info-wrapper">
								<div class="popup-info-row">
									<i class="fa fa-clock" style="font-size: 30px; min-width: 48px; text-align: center;" title="Event Duration"></i>
									<span style="font-size: 22px; font-weight: bold;">${getDurationTimeFormat(event.duration)}<span style="font-size: 14px; text-align: center;">${getDurationUnitFormat(event.duration).toUpperCase()}</span></span>
								</div>
								<div class="popup-info-row">
									<div class="menuItem speed" title="Speed Moving"></div>
									<span style="font-size: 22px; font-weight: bold;">${vehicleSpeed()}<span style="font-size: 14px;">${user.speed_unit.toUpperCase()}</span></span>
								</div>
							</div>
							<div class="popup-info-row">
								<div class="speed-limit-wrapper">
									<div class="speed-limit-label">${t('homePage.tripSpeedEventPopup.textSpeed')}</div>
									<div class="speed-limit-label">${t('homePage.tripSpeedEventPopup.textLimit')}</div>
									<div class="speed-limit-label speed">${vehicleSpeedLimit()}</div>
								</div>
								<label class="speed-unit-label">${user.speed_unit.toUpperCase()}</label>
							</div>
						</div>
					</div>
					
				</div>
				<div class="addressWrapper">
					<div style="min-height: 60px; padding-top: 14px; font-size: 16px; font-weight: bold; text-align: center;">
						<a id="requestVideoLink" href="/" class="link-request">${t('homePage.tripSpeedEventPopup.requestVideo')}</a>
					</div>
				</div>
			</div>
		</div>`;

		setTimeout(() => {
			const requestLink = content.querySelector("#requestVideoLink");
			if (requestLink) {
				requestLink.addEventListener("click", createCustomClip);
			}
		}, 0);

		return content;
	}

	useEffect(() => {
		if (!position) return;

		let bubbleEl = mapUI.getBubbles().find(bubble =>
			bubble.getElement().classList.contains("tripSpeedBubble")
		);
		const content = getContent();
		if (bubbleEl) {
			bubbleEl.setPosition(position);
			bubbleEl.setContent(content);
		} else {
			bubbleEl = new H.ui.InfoBubble(position, { content });
			bubbleEl.addClass("infoTripBubble");
			bubbleEl.addClass("tripSpeedBubble");
			mapUI.addBubble(bubbleEl);
		}
		bubbleEl.removeEventListener("statechange", handleBubbleClose);
		bubbleEl.addEventListener("statechange", handleBubbleClose);

		function handleBubbleClose(e) {
			if (e.target.getState() === H.ui.InfoBubble.State.CLOSED) {
				setShowSpeedEventPopup(false);
				mapUI.getBubbles().forEach(bubble => {
					if (bubble.getElement().classList.contains("tripSpeedBubble")) {
						mapUI.removeBubble(bubble);
					}
				});
			}
		}
	}, [position, mapUI]);

	return (<></>)
}

TripSpeedEventPopup.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	event: PropTypes.objectOf(PropTypes.any).isRequired,
	device_id: PropTypes.string.isRequired,
	position: PropTypes.objectOf(PropTypes.any).isRequired,
	selectedTrip: PropTypes.objectOf(PropTypes.any)
};

const mapStateToProps = ({ user }) => ({
	user: user.user,
});

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TripSpeedEventPopup);
